import React from "react"
import { Navigate, Outlet, useSearchParams } from "react-router-dom"

import { restoreUuidDashes } from "shared/lib/UUIDUtils"

import { validate } from "uuid"

export const ProjectIDVerifier = React.memo(() => {
  const [params] = useSearchParams()
  const projectID = params.get("project_id")
  const projectShareID = params.get("shared_project_id")

  if (projectID && !validate(projectID)) {
    return (
      <Navigate
        to={`/project-details?project_id=${
          restoreUuidDashes(projectID) as string
        }`}
        replace
      />
    )
  }

  if (projectShareID && !validate(projectShareID)) {
    return (
      <Navigate
        to={`/shared-project-details?shared_project_id=${
          restoreUuidDashes(projectShareID) as string
        }`}
        replace
      />
    )
  }

  return <Outlet />
})
